const isChildInParentView = (parent, child) => {
  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  return childRect.top > parentRect.top && childRect.bottom < parentRect.bottom;
};

const stripElementIds = node => {
  if (node && node.removeAttribute) {
    node.removeAttribute("id");
  }
  if (node.childNodes) {
    Array.from(node.childNodes).forEach(n => stripElementIds(n));
  }
  return node;
};

const hasNoSiblings = node => node.parentNode.children.length === 1;

export { hasNoSiblings,isChildInParentView, stripElementIds };
